import { Wind, Snowflake, WashingMachine, Drop, Thermometer, Oven, Television, CloudFog, Package, BatteryCharging, Fan, Question } from "@phosphor-icons/react";

// Single source of truth for appliance type metadata on the frontend — mirrors the backend's
// APPLIANCE_TYPES/APPLIANCE_TYPE_LABELS in services/invoice_document_extractor.py.
export const APPLIANCE_TYPES = [
    { key: "air_conditioner", label: "Air Conditioner", icon: Wind, color: "#5AA0C8" },
    { key: "refrigerator", label: "Refrigerator", icon: Snowflake, color: "#3C7DC8" },
    { key: "washing_machine", label: "Washing Machine", icon: WashingMachine, color: "#8B5CF6" },
    { key: "water_purifier", label: "Water Purifier", icon: Drop, color: "#1B8A9C" },
    { key: "geyser_water_heater", label: "Geyser / Water Heater", icon: Thermometer, color: "#FF6B1A" },
    { key: "microwave_oven", label: "Microwave / Oven", icon: Oven, color: "#E5A73C" },
    { key: "television", label: "Television", icon: Television, color: "#4B5563" },
    { key: "chimney", label: "Chimney", icon: CloudFog, color: "#7A7A7A" },
    { key: "dishwasher", label: "Dishwasher", icon: Package, color: "#4C8577" },
    { key: "inverter_ups", label: "Inverter / UPS", icon: BatteryCharging, color: "#B08B2E" },
    { key: "ceiling_fan", label: "Ceiling Fan", icon: Fan, color: "#5A8FC8" },
    { key: "other", label: "Other", icon: Question, color: "#4B5563" },
];
export const APPLIANCE_TYPE_MAP = Object.fromEntries(APPLIANCE_TYPES.map((a) => [a.key, a]));

export const EMPTY_APPLIANCE_FORM = {
    appliance_type: "air_conditioner", other_type_label: "", brand: "", model: "",
    serial_number: "", description: "", purchase_date: "", invoice_number: "",
    purchase_price: "", seller_name: "", seller_contact: "",
    warranty_duration: "", warranty_start_date: "", warranty_end_date: "", warranty_provider: "",
    installation_date: "", amc_provider: "", amc_start_date: "", amc_end_date: "", amc_cost: "",
    notes: "", invoice_file_id: "",
};

// Maps an extraction result item (services/invoice_document_extractor.py shape) onto the form.
export function itemToForm(item) {
    return {
        appliance_type: (item.appliance_type && APPLIANCE_TYPE_MAP[item.appliance_type]) ? item.appliance_type : "other",
        other_type_label: "",
        brand: item.brand || "",
        model: item.model || "",
        serial_number: item.serial_number || "",
        description: item.description || "",
        purchase_date: item.purchase_date || "",
        invoice_number: item.invoice_number || "",
        purchase_price: item.purchase_price != null ? String(item.purchase_price) : "",
        seller_name: item.seller_name || "",
        seller_contact: item.seller_contact || "",
        warranty_duration: item.warranty_duration || "",
        warranty_start_date: item.warranty_start_date || "",
        warranty_end_date: item.warranty_end_date || "",
        warranty_provider: item.warranty_provider || "",
        installation_date: item.installation_date || "",
        amc_provider: "", amc_start_date: "", amc_end_date: "", amc_cost: "",
        notes: "", invoice_file_id: "",
    };
}
